// app-promotion.service.ts
import { Injectable, inject } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { AppPromotionComponent } from '../components/app-promotion/app-promotion.component';
import { TranslateService } from '@ngx-translate/core';


@Injectable({
  providedIn: 'root'
})
export class AppPromotionService {
  public translateService =inject(TranslateService);
  private bottomSheet = inject(MatBottomSheet);
  private readonly DISMISSED_KEY = 'app-promotion-dismissed';
  private readonly EXPIRATION_DAYS = 14;
  private readonly DELAY = 3000; // 

  showPromotionBanner(os): void {
    if (this.hasUserDismissed()) {
      return;
    }
    // Wait before showing
    setTimeout(() => {     
      const lang = this.translateService.getCurrentLang()
      const sheetRef = this.bottomSheet.open(AppPromotionComponent, {
        data: { os, lang},
        disableClose: false,
        panelClass: ['app-promotion'],
        hasBackdrop: true,
        backdropClass:'backdrop-transparent'
      });

       sheetRef.afterDismissed().subscribe(() => {
         this.setAsDismissed();
       });
    }, this.DELAY);
  }


  private hasUserDismissed(): boolean {
    //return localStorage.getItem(this.DISMISSED_KEY) === 'true';
        const stored = localStorage.getItem(this.DISMISSED_KEY);
    
    if (!stored) {
      return false;
    }
    
    try {
      const data = JSON.parse(stored);
      const expirationTime = data.expiresAt;
      const now = new Date().getTime();
      if (now > expirationTime) {
        localStorage.removeItem(this.DISMISSED_KEY);
        return false;
      }      
      //valid
      return true;
    } catch {
      localStorage.removeItem(this.DISMISSED_KEY);
      return false;
    }
  }

  private setAsDismissed(): void {
    localStorage.setItem(this.DISMISSED_KEY, 'true');
    const expiresAt = new Date().getTime() + (this.EXPIRATION_DAYS * 24 * 60 * 60 * 1000);    
    localStorage.setItem(
      this.DISMISSED_KEY,
      JSON.stringify({
        dismissed: true,
        dismissedAt: new Date().toISOString(),
        expiresAt: expiresAt
      })
    );
  }
}